import { HydratedChatbotAsset } from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import AssetRow from "./AssetRow";
import { HydratedChatbotWithFolder, useChatbotRow } from "@zapier/chatbots";
import { ChatbotModal } from "@zapier/chatbots/src/chatbots/ChatbotsTable/ChatbotModals";
import { FolderModal } from "@zapier/shared";

interface Props {
  allowSelection?: boolean;
  chatbot: HydratedChatbotAsset;
  setCurrentModal: (modal: ChatbotModal | FolderModal | undefined) => void;
  setCurrentChatbot: (
    chatbot: HydratedChatbotWithFolder | HydratedChatbotAsset | undefined,
  ) => void;
  folderId?: string;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
  onCopyToAnotherAccount?: (asset: HydratedChatbotAsset) => void;
}

export function AssetRowChatbot({
  allowSelection,
  chatbot,
  setCurrentModal,
  setCurrentChatbot,
  folderId,
  showLastRun,
  showLocationColumn,
  onCopyToAnotherAccount,
}: Props) {
  const tShared = useTranslations("fallbacks");
  const { menuItems, triggerPermissionsCheck } = useChatbotRow({
    chatbot,
    setCurrentModal,
    setCurrentChatbot,
    onCopyToAnotherAccount,
  });

  return (
    <AssetRow
      allowSelection={allowSelection}
      asset={chatbot}
      folderZapTableRow={true}
      isUntitled={chatbot?.name?.length === 0}
      title={
        chatbot.name || tShared("untitled-asset", { assetType: "Chatbot" })
      }
      updatedAt={new Date(chatbot.updatedAt ?? "")}
      onOpenMenu={triggerPermissionsCheck}
      menuItems={menuItems}
      folderId={folderId}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
    />
  );
}
